// extracted by mini-css-extract-plugin
module.exports = {"bodywrapper":"chat_bodywrapper__1_uwS","bodywrapper2":"chat_bodywrapper2__2ot0L","page-title":"chat_page-title___rGyq"};